import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { AutoComplete, Col, Flex, Input, Layout, Row, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useWorkbenchStore } from "../stores/context";
import {
    SubjectInfoWidget,
    TasksWidget,
    DocumentsWidget,
    ActionsHistoryWidget,
} from "../components/";

const WorkbenchPage: React.FC = () => {
    const context = useWorkbenchStore();
    const { workbenchStore } = context;

    useEffect(() => {
        void workbenchStore.loadInitialData();
    }, [workbenchStore]);

    const handleSearchChange = (value: string) => {
        workbenchStore.setSearchInput(value);
    };

    const handleSelect = async (value: string) => {
        await workbenchStore.selectSubjectByValue(value);
    };

    const searchOptions = workbenchStore.subjectSuggestions.map((subject) => ({
        value: workbenchStore.getSubjectOptionValue(subject),
        label: (
            <div>
                <div>{workbenchStore.getSubjectOptionValue(subject)}</div>
                <div style={{ color: "#888", fontSize: 12 }}>
                    {subject.cedent || subject.id}
                </div>
            </div>
        ),
    }));

    return (
        <Layout className="screen-size wb-layout">
            <div className="header-wrapper">
                <div className="title-wrapper">
                    <div className="header-title">Workbench</div>
                </div>
            </div>
            <Flex justify="center" className="search-row">
                <AutoComplete
                    style={{ width: "100%", maxWidth: 720 }}
                    value={workbenchStore.searchInput}
                    options={searchOptions}
                    onChange={handleSearchChange}
                    onSelect={handleSelect}
                    notFoundContent={
                        workbenchStore.isSubjectSearchLoading ? (
                            <Spin size="small" />
                        ) : workbenchStore.subjectSearchError ? (
                            workbenchStore.subjectSearchError
                        ) : workbenchStore.searchInput.trim().length >= 2 ? (
                            "No subjects found"
                        ) : null
                    }
                >
                    <Input
                        allowClear
                        prefix={<SearchOutlined />}
                        placeholder="Search subjects by identifier, cedent, broker, or claimant"
                    />
                </AutoComplete>
            </Flex>
            <Row gutter={[16, 16]} align="stretch">
                <Col xs={24} lg={12} xxl={8}>
                    <SubjectInfoWidget />
                </Col>
                <Col xs={24} lg={12} xxl={8}>
                    <TasksWidget />
                </Col>
                <Col xs={24} lg={12} xxl={8}>
                    <DocumentsWidget />
                </Col>
                <Col xs={24} lg={12} xxl={8}>
                    <ActionsHistoryWidget />
                </Col>
            </Row>
        </Layout>
    );
};

export default observer(WorkbenchPage);
